import React from 'react';
import { Box, Flex, Heading } from '@chakra-ui/react';

export const BRAND_BLUE = '#1885F2';

// Shared line height for the person's name (left column) and the section titles (right
// column), so the name lines up with the first section title.
export const TITLE_LINE_HEIGHT = '40px';

// A section title on the public sharing page, followed by a short blue line.
const SectionTitle = ({ children, font, mb = 4 }) => (
  <Flex align="center" gap={5} mb={mb}>
    <Heading
      as="h2"
      fontFamily={font}
      fontSize={{ base: '22px', md: '24px' }}
      fontWeight="700"
      lineHeight={TITLE_LINE_HEIGHT}
      color="#0B151F"
      letterSpacing="0"
    >
      {children}
    </Heading>
    <Box as="span" aria-hidden="true" data-testid="section-title-line" w="72px" h="2px" bg={BRAND_BLUE} flexShrink={0} />
  </Flex>
);

export default SectionTitle;
